import { TranslationKeyTranslation } from '../../../models/translation';
import { WeekDayEnum } from '../../../models/weekday.enum';

export const translationsFr: TranslationKeyTranslation = {
  yes: 'Oui',
  no: 'Non',
  all: 'Tous',
  job: 'Service',
  jobSeries: 'Série de services',
  jobRequest: 'Demande de service',
  german: 'Allemand',
  english: 'Anglais',
  french: 'Français',
  created: 'Créé',
  updated: 'Mis à jour',
  status: 'Statut',
  loadAll: 'Tout charger',
  loadMore: 'Charger plus',
  download: 'Télécharger',
  cancelItem: 'Annuler',
  externalCancellations: 'Annulations externes',
  duplicate: 'Dupliquer',
  summary: 'Résumé',
  clearSelection: 'Effacer la sélection',
  fieldRequiredError: 'Veuillez remplir ce champ obligatoire',
  overlappingTrackings: 'Veuillez corriger les horaires qui se chevauchent',
  badTimeSpan: 'Les horaires de début et de fin ne peuvent pas être identiques',
  pauseTooBig: 'La pause ne peut pas être plus longue que le temps de travail',
  submit: 'soumettre',
  name: 'Nom',
  firstName: 'Prénom',
  lastName: 'Nom de famille',
  email: 'E-mail',
  sms: 'SMS',
  phone: 'Téléphone',
  password: 'Mot de passe',
  setPassword: 'Définir le mot de passe',
  resetPassword: 'Réinitialiser le mot de passe',
  forgotPassword: 'Mot de passe oublié?',
  newPassword: 'Nouveau mot de passe',
  repeatPassword: 'Répéter le mot de passe',
  passwordDoesntMatch: 'Les mots de passe ne correspondent pas',
  passwordIsToShort: 'Le mot de passe est trop court.',
  required: 'Obligatoire',
  inputDoesNotMatch: 'La saisie ne correspond pas',
  login: 'se connecter',
  loading: 'Chargement...',
  loggingIn: 'Connexion en cours...',
  reset: 'réinitialiser',
  goToLogin: 'aller à la connexion',
  add: 'ajouter',
  cancel: 'Annuler',
  back: 'retour',
  search: 'rechercher...',
  sex: 'Sexe',
  maleSex: 'Homme',
  femaleSex: 'Femme',
  otherSex: 'Autre',
  salutation: 'Civilité',
  mr: 'Monsieur',
  mrs: 'Madame',
  date: 'Date',
  weekday: 'Jour de la semaine',
  timeOfDay: 'Heure',
  cancelTime: 'Annuler le temps',
  dateFrom: 'Date de début',
  dateTo: 'Date de fin',
  startDate: 'Date de début',
  endDate: 'Date de fin',
  startTime: 'Heure de début',
  endTime: 'Heure de fin',
  bookedAt: 'Gebucht am',
  total: 'Total',
  employees: 'Employés',
  employee: 'Employé',
  save: 'enregistrer',
  edit: 'modifier',
  remove: 'supprimer',
  details: 'Détails',
  welcome: 'bienvenue',
  state: 'État',
  confirm: 'confirmer',
  description: 'Description',
  close: 'fermer',
  hide: 'cacher',
  filter: 'Filtre',
  decline: 'refuser',
  moreOptions: 'plus d’options',
  transfer: 'transférer',
  transcribe: 'Transférer',
  done: 'Terminé',
  toComplete: 'Marquer comme terminé',
  areYouSure: 'Êtes-vous sûr ?',
  areYouSurePolite: 'Êtes-vous sûr ?',
  unsavedChangesTitle: 'Modifications non enregistrées',
  unsavedChangesText:
    'Vous avez des modifications non enregistrées. Voulez-vous vraiment continuer ?',
  pleaseEnterName: 'Veuillez entrer votre nom complet.',
  orderId: 'Numéro de commande',
  branch: 'Succursale',
  create: 'créer',
  new: 'nouveau',
  from: 'de',
  to: 'à',
  pause: 'pause',
  selectDateRange: 'Sélectionner une période',
  noUsersFound: 'Aucun employé trouvé',
  showAll: 'Afficher tout',
  showLess: 'Afficher moins',
  or: 'ou',
  editor: 'Éditeur:trice',
  creator: 'Créateur:trice',
  availabilities: 'Disponibilités',
  jobAvailabilities: 'Disponibilités pour les services',
  employmentAvailabilities: 'Disponibilités pour les missions temporaires',
  organisationAndDepartment: 'Organisation, Département',
  timespan: 'Période',
  now: 'Maintenant',
  request: 'Demande',
  availabilitiesNoUmlaut: 'Disponibilites',
  availabilitiesTemporary: 'Disponibilités temporaires',
  availability: 'Disponibilité',
  label: 'Désignation',
  notificationType: 'Type de notification',
  weekdays: {
    [WeekDayEnum.MONDAY]: 'Lundi',
    [WeekDayEnum.TUESDAY]: 'Mardi',
    [WeekDayEnum.WEDNESDAY]: 'Mercredi',
    [WeekDayEnum.THURSDAY]: 'Jeudi',
    [WeekDayEnum.FRIDAY]: 'Vendredi',
    [WeekDayEnum.SATURDAY]: 'Samedi',
    [WeekDayEnum.SUNDAY]: 'Dimanche',
  },
  carLicenseEnum: {
    '0': 'Permis de conduire disponible',
    '1': 'Voiture et permis de conduire disponibles',
  },
  languageEnum: {
    '0': 'Allemand',
    '1': 'Anglais',
    '2': 'Italien',
    '3': 'Français',
  },
  poolerType: 'Type d’emploi',
  mobility: 'Mobilité',
  languages: 'Langues',
  language: 'Langue',
  systemLanguage: 'Langue du système',
  departments: 'Départements',
  department: 'Département',
  clinic: 'Clinique',
  section: 'Section',
  all_departments: 'Tous les départements',
  available: 'disponible',
  unavailable: 'absent',
  booked: 'réservé',
  shift: 'Service',
  shiftPlural: 'Services',
  shiftNotAvailableOnDepartment: 'Service non disponible dans ce département',
  customer: 'Client',
  agency: 'Agence',
  offerFrom: 'Offre de',
  all_agencies: 'Toutes les agences',
  verify: 'vérifier',
  twoFa: 'Authentification à deux facteurs',
  resendAuthCode: 'Renvoyer le code',
  authCodeSentTo: 'Nous avons envoyé un code de confirmation à',
  authCodeSentToYourPhone: 'votre téléphone. Veuillez entrer le code ici.',
  codeInvalidOrExpired: 'Code invalide ou expiré',
  requiredField: 'Champ obligatoire',
  emailInvalid: 'E-mail invalide',
  phoneConfirmation: 'Confirmation du téléphone',
  noPoolerFound: 'Aucun pooler trouvé',
  phoneNumber: 'Numéro de téléphone',
  emailAddress: 'Adresse e-mail',
  additionalInfo: 'Informations supplémentaires',
  additionalAvailabilityInfo:
    'Informations supplémentaires sur la disponibilité',
  additionalAvailabilityInfoPlaceholder:
    'p. ex. disponible uniquement jusqu’à 22h',
  statusEnum: {
    '0': 'Ouvert',
    '1': 'Archivé',
    '2': 'fermé',
    '3': 'refusé',
    '4': 'Disponible',
    '5': 'Non disponible',
    '6': 'Réservé',
    '7': 'demandé',
    '8': 'Non trouvé',
    '9': 'Annulé',
    '10': 'En cours',
    '11': 'Pool supprimé',
    '12': 'Présent',
    '13': 'Candidat potentiel',
  },
  jobStatusEnum: {
    OPEN: 'Ouvert',
    ARCHIVED: 'Archivé',
    CLOSED: 'fermé',
    CANCELED: 'Annulé',
    JOB_REQUESTED: 'demandé',
  },
  inviteeStatusEnum: {
    OPEN: 'Ouvert',
    DECLINED: 'refusé',
    AVAILABLE: 'Disponible',
    UNAVAILABLE: 'Non disponible',
    BOOKED: 'Réservé',
    CANCELED: 'Annulé',
    WORKING: 'En cours',
    POSSIBLE_CANDIDATE: 'Candidat potentiel',
    TRANSFERRED: 'Transféré',
    PARTIAL_AVAILABLE: 'Partiellement disponible',
  },
  customerUserStatusEnum: {
    REQUESTED: 'demandé',
    INEXISTENT: 'Non trouvé',
    POOL_REMOVED: 'Pool supprimé',
    EXISTENT: 'Présent',
  },
  submitted: 'Soumis',
  bookedBy: 'Réservé par',
  bookedIn: 'Réservé dans',
  availabilityOverviewBookedCounts: 'Réservé dans ce service / Total réservé',
  perPooler: 'par pooler',
  perDepartment: 'par département',
  perOrganisation: 'par organisation',
  organisations: 'Organisations',
  organisation: 'Organization',
  addTag: 'Ajouter un tag',
  originalCertificates: 'Certifications originales',
  originalSpecialities: 'Spécialités originales',
  originalSex: 'Sexe original',
  originalCar: 'Mobilité originale',
  originalLanguage: 'Langue originale',
  originally: 'Originalement',
  empty: 'vide',
  createLink: 'Créer un lien',
  hours: 'Heures',
  toAdd: 'ajouter des heures',
  toApprove: 'à approuver',
  approved: 'approuvé',
  inviteeTransferReason: 'Raison du transfert',
  transferInviteTarget: 'Destination du transfert',
  transferCreateNewJob: 'Nouveau service',
  disabledBecauseExternalTransfer:
    'L’ajustement des critères est désactivé car le service a été transféré à des agences externes. Les qualifications peuvent être ajoutées, mais pas supprimées.',
  createNewTag: 'Créer un nouveau tag',
  reports: 'Rapports',
  informInviteeOfReason: 'Informer l’employé de la raison',
  selectAllDepartments: 'Sélectionner tous les départements visibles',
  deselectAllDepartments: 'Désélectionner tous les départements visibles',
  allDepartments: 'Tous les Départements',
  areYouSureSelectAllDepartments:
    'Êtes-vous sûr de vouloir sélectionner tous les départements visibles?',
  areYouSureDeselectAllDepartments:
    'Êtes-vous sûr de vouloir désélectionner tous les départements visibles?',
  approvedAt: 'Approuvé le',
  approvedBy: 'Approuvé par',
  timeTracking: 'Suivi du temps',
  disableTimeTracking: 'Désactiver le suivi du temps',
  disableTimeTrackingDescription:
    'Si vous désactivez le suivi du temps, vous ne pourrez pas enregistrer d’heures et les enregistrements d’heures en attente seront supprimés.',
  enableTimeTracking: 'Activer le suivi du temps',
  enableTimeTrackingDescription:
    'Si vous activez le suivi du temps, cela s’appliquera à tous les services créés à l’avenir, mais pas aux services déjà créés.',
  jobType: 'Type de service',
  jobTypeEnum: {
    '1': 'Normal',
    '2': 'Surveillance assise',
    '3': '1 à 1',
  },
  demandReason: 'Raison de la demande',
  demandReasonEnum: {
    WORKLOAD: 'Dernier travail / Soins élaborés',
    LACK_OF_STAFF: 'Pénurie de personnel / Poste ouvert',
    ACCIDENT: 'Accident',
    SICKNESS: 'Maladie',
    ONE_ON_ONE: 'Soins 1:1',
    PATIENT_SITTING: 'Surveillance assise',
    OTHER: 'Autre raison',
  },
  cancelCostWarningTitle: 'Frais d’annulation possibles',
  cancelCostWarningMessage:
    'Vous annulez une personne dans la période de résiliation. Si vous avez des questions, veuillez contacter votre courtier. \n Voulez-vous quand même continuer?',
  maleGreeting: 'Cher',
  femaleGreeting: 'Chère',
  neutralGreeting: 'Bonjour',
  sincerely: 'Cordialement',
  noReplyMessage:
    'Ceci est un e-mail généré automatiquement. Veuillez ne pas y répondre.',
  buttonNotWorking: 'Le bouton ne fonctionne pas ?',
  requestType: 'Type de demande',
  endpoint: 'Point de terminaison',
  requestBody: 'Corps de la demande',
  errorMessage: 'Message d’erreur',
  key: 'Champ',
  newValue: 'Nouvelle valeur',
  oldValue: 'Ancienne valeur',
  jobPool: 'Pool de services',
  employmentPool: 'Pool de missions temporaires',
  calendarWeekShort: 'Sem',
  employmentDuration: 'Durée de la mission',
  newEmployment: 'Nouvelle mission',
  declined: 'Refusé',
  address: 'Adresse',
  departmentPhone: 'Numéro de département',
  workload: 'Pensum',
  workloadInPercent: 'Pensum en pourcentage',
  newVersionTitle: 'Nouvelle version disponible',
  newVersionText:
    'Veuillez recharger la page pour utiliser la dernière version.',
  reload: 'Recharger',
  declineReasonEnum: {
    CERTIFICATE_NOT_FIT: 'Qualification non adaptée',
    BAD_PRIOR_EXPERIENCE:
      'Performance insuffisante lors de la dernière mission',
    OTHER_INVITEE_BOOKED: 'Un autre employé a été réservé',
    JOB_CANCELLED: 'Service annulé',
    OTHER: 'Autre raison',
  },
  certificates: 'Qualification',
  specialities: 'Expérience / Secteur de soins',
  transferredBy: 'Transféré par',
  createdBy: 'Créé par',
  list: 'Liste',
  calendar: 'Calendrier',
  shifts: {
    '0': 'Matin',
    '1': 'Midi',
    '2': 'Soir',
    '3': 'Nuit',
  },
  shiftLetters: {
    '0': 'M',
    '1': 'J',
    '2': 'S',
    '3': 'N',
  },
  jobRequests: 'Gestion du service',
  userRole: 'Rôle',
  roleEnum: {
    0: 'employé',
    1: 'gestionnaire',
    2: 'chef de service',
  },
  agencies: 'agences',
  continue: 'Continuer',
  jobTypes: 'Types de services',
  tiles: 'Tiles',
  inEmployment: 'En mission',
  saved: 'Enregistré',
  profileSaved: 'Profil enregistré',
  jobSaved: 'Service enregistré',
  serverError: 'Erreur du serveur',
  wrongOrExpiredToken: 'Token incorrect ou expiré',
  documentUploaded: 'Document téléchargé avec succès',
  saveJobBeforeTransfer:
    'Veuillez enregistrer vos modifications avant le transfert',
  documentRemoved: 'Document supprimé avec succès',
  xNewJobsCreated: '{{count}} nouveaux services créés',
  noUserConnectedWithMicrosoft:
    "Aucun utilisateur n'est connecté avec Microsoft",
  loginExpired:
    'Votre session a expiré. Veuillez vous reconnecter pour continuer',
  multidayUsersInvitedAndBooked:
    '{{inviteCount}} employés invités et {{bookCount}} employés réservés',
  multidayUsersInvited: '{{count}} employés invités',
  multidayUsersBooked: '{{count}} employés réservés',
  registerSuccess:
    'Merci pour votre inscription, nous vous contacterons prochainement',
  notAllowed: "Vous n'êtes pas autorisé à faire cela",
  notSupported: 'Votre navigateur ne prend pas en charge cette fonction',
  sentInvitation: 'Invitation envoyée',
  maxFileUploadExceeded: 'Taille maximale du fichier dépassée',
  noCustomerAssigned: 'Aucun client assigné à cet utilisateur',
  phoneNumberOccupied: 'Ce numéro est déjà utilisé',
  newJobCreated: 'Service créé',
  jobClosed: 'Service terminé',
  reAskedInvitee: 'Employé demandé à nouveau',
  jobTransferred: 'Service transféré',
  jobCanceled: 'Service annulé',
  inviteeCanceled: 'Employé réservé annulé',
  passwordResetEmailSent: 'E-mail de réinitialisation du mot de passe envoyé',
  xJobsDeclined: '{{count}} services ont été refusés',
  jobOverlapsDetectedForNames: 'Les services se chevauchent pour {{names}}',
  userNotFound: 'Utilisateur non trouvé',
  couldntCreateTag: 'Impossible de créer le tag',
  tagAlreadyExists: 'Le tag existe déjà',
  tagStillInUse: 'Le tag est encore utilisé',
  tagAlreadyOnOrganisation: "Le tag est déjà attribué à l'organisation",
  couldntDeleteTag: 'Impossible de supprimer le tag',
  successfullyDeletedTag: 'Tag supprimé avec succès',
  tagAdded: 'Tag ajouté',
  tagRemoved: 'Tag supprimé',
  userRemovedFromPool: 'Utilisateur retiré du pool',
  usernameOrPasswordWrong: 'E-mail ou mot de passe incorrect',
  cannotViewMoreThan90Days: 'La période ne peut pas dépasser 90 jours.',
  demoResetNotice:
    "Bienvenue dans la démo d'in-pool. Veuillez noter que les notifications par e-mail et SMS sont désactivées par défaut dans la démo. Toutes les données sont réinitialisées chaque nuit",
  optInEmailMessage:
    'Veuillez confirmer la nouvelle adresse e-mail en cliquant sur le lien de confirmation que nous vous avons envoyé par e-mail',
  optInPhoneMessage:
    'Veuillez confirmer le nouveau numéro de téléphone en cliquant sur le lien de confirmation que nous vous avons envoyé par SMS',
  sentNewSMSToken: 'Code de confirmation SMS envoyé.',
  confirmEmailLink:
    'Veuillez confirmer votre adresse e-mail en cliquant sur le lien que nous vous avons envoyé par e-mail.',
  optInEmailExists: 'Un compte avec cette adresse e-mail existe déjà.',
  optInPhoneExists: 'Un compte avec ce numéro de téléphone existe déjà.',
  optInSuccessMessage: 'La modification a été confirmée avec succès',
  optInErrorMessage:
    "La modification n'a pas pu être effectuée. Le lien utilisé a peut-être expiré, est incomplet ou n'est pas valide pour cet utilisateur. Veuillez recommencer la modification",
  alreadyInPool:
    'Un utilisateur avec cette adresse e-mail est déjà dans le pool',
  alreadyRequested: "L'utilisateur a déjà été invité",
  alreadyAdded: 'Cet utilisateur a déjà été ajouté',
  changeEmailNotAllowedForNewUser:
    "L'adresse e-mail ne peut pas être modifiée lors de la création d'un nouvel utilisateur",
  userCreated: 'Utilisateur créé avec succès',
  savedDefaultFilter: 'Filtre enregistré comme valeur par défaut',
  userInvitedAgain: 'Utilisateur invité à nouveau',
  userUnlocked: 'Utilisateur déverrouillé',
  connectionLost: 'Connexion perdue. Tentative de reconnexion automatique...',
  connectionOffline:
    'Connexion interrompue. Veuillez vous assurer que vous êtes connecté à Internet et recharger la page.',
  hoursTransferred: 'Heures transférées',
  successfullyAddedInvitee: 'Employé ajouté avec succès',
  JobNotFound: 'Service non trouvé',
  userAlreadyExistsAsDispo:
    "L'utilisateur est déjà enregistré en tant que planificateur",
  userAlreadyExistsAsPooler:
    "L'utilisateur est déjà enregistré en tant qu'employé",
  JobNotOpen: "Le service n'est plus ouvert",
  SecretInvalid: 'Autorisation refusée',
  InvalidForm: 'Veuillez remplir tous les champs obligatoires',
  JobAutomaticallyClosed: 'Service fermé automatiquement',
  transferDeclined: 'Service refusé avec succès',
  removedSuccessfully: 'Supprimé avec succès',
  downloadedSuccessfully: 'Téléchargé avec succès',
  fileNotFound: 'Ce fichier est introuvable',
  jobInsertError: 'Erreur lors de la création du service',
  multiJobInsertError: "Un ou plusieurs services n'ont pas pu être créés",
  cantBookInvitee: "Impossible de réserver l'employé",
  cantBookReasonUserBlacklistedDepartment:
    "L'employé a mis ce département sur liste noire",
  cantBookReasonDepartmentNotAssigned:
    "L'employé n'a pas le département du service assigné",
  cantBookReasonNotAvailable: "L'employé n'est pas disponible pour ce service",
  cantBookReasonDepartmentBlacklistedUser:
    'Le département a mis cet employé sur liste noire',
  cantBookReasonCanBeBooked: "L'employé peut être réservé pour ce service",
  loginForbidden: 'Connexion refusée',
  authCodeResent: 'Code de confirmation renvoyé',
  phoneNotFound: 'Aucun numéro de téléphone valide trouvé.',
  phoneNotVerified: 'Numéro de téléphone non vérifié.',
  contactSupport: 'Veuillez contacter le support.',
  InviteesAlreadyExists: 'Employé déjà présent',
  inviteeTransferred: 'Transféré avec succès',
  inviteeDoesNotFitCriteria: "L'employé invité ne correspond pas aux critères",
  inviteeNoLongerFitCriteria:
    "L'employé invité ne correspond plus aux critères",
  requiredUsersBelowBookedCount:
    'Les employés requis ne peuvent pas être inférieurs au nombre déjà réservé',
  inviteeInvitedTwice: 'Employé déjà invité',
  duplicateInvitationError:
    'Il y a un problème avec le service (Invitation en double). Veuillez recharger la page et réessayer.',
  duplicateInvitationErrorUnclearableStatus:
    'Il y a un problème avec le service (Invitation en double). Veuillez contacter le support immédiatement.',
  linkCopied: 'Lien copié',
  inviteeHasNotHadMinimumRest:
    "L'employé invité n'a pas respecté le temps de repos minimum",
  externalNoLongerDraft:
    "Le service n'est plus un brouillon dans le transfert externe",
  userBookedSuccessfullyEmployment: 'Employé réservé pour la mission',
  userSuccessfullySubmittedAsEmploymentPossibleCandidate:
    'Employé soumis avec succès comme candidat potentiel pour la mission',
  userCanceledSuccessfullyEmployment: 'Employé annulé pour la mission',
  userBookedSuccessfullyJob: 'Employé réservé pour le service',
  employmentCanceled: 'Mission annulée',
  employeesInvitedSuccessfully: 'Employés invités avec succès',
  employmentCreated: 'Mission créée avec succès',
  requiredFieldsMissing: 'Veuillez remplir tous les champs obligatoires',
  changesSaved: 'Modifications enregistrées',
  jobRequestInsertError: 'Erreur lors de la création de la demande de service',
  newJobRequestCreated: 'Nouvelle demande de service créée',
  xNewJobRequestsCreated: '{{count}} demandes de service créées',
  jobRequestRetractError:
    'Erreur lors de la rétractation de la demande de service',
  jobRequestRetracted: 'Demande de service rétractée',
  jobRequestApproved: 'Demande de service approuvée',
  jobRequestRejected: 'Demande de service refusée',
  settings: 'Paramètres',
  superAdmin: 'Super Admin',
  demoSettings: 'Paramètres de démonstration',
  jobMatrix: 'matrice de planification',
  demoValidUntil: "Démo valable jusqu'au",
  qualification: 'Qualification',
  potentialInviteeCount: 'Disponible',
  noShiftsForWeekDaysHint:
    'Aucun service disponible pour ce jour de la semaine',
  noShiftsForJobTypeHint: 'Aucun service disponible pour ce type de service',
  noShiftsAvailableHint: 'Aucun service configuré pour ce département',
  cancelSomething: 'Annuler quelque chose',
  submitPossibleCandidate: 'Soumettre comme candidat potentiel',
  sickness: 'Maladie',
  accident: 'Accident',
  PersonnelDeclined: 'Personnel refusé',
  customerDeclined: 'Client a annulé',
  restTimeAfter7WorkingDays:
    'Temps de repos après 7 jours de travail non respecté',
  otherJobOffer: 'Autre offre de service',
  sharedPoolCustomers: 'Clients avec accès au Pool partagé',
  sharedPoolCanDirectBook: 'peut réserver directement',
  noSharedPoolCustomers: 'Aucun client avec accès à ce Pool partagé trouvé.',
  noCapacity: 'Pas de capacité',
  requesterOverview: "Vue d'ensemble des demandeurs",
  requesterAssignmentReportDescription:
    'Aperçu de tous les demandeurs et de leurs autorisations',
  autoBookInviteesCardTitle: 'Réservation automatique',
  autoBookInvitees:
    "Réserver automatiquement les employés invités en cas d'acceptation",
  autoBookInviteesDepartmentDefault:
    " Activer par défaut la réservation automatique des employés invités en cas d'acceptation pour les services",
  autoBookSelfSignIns:
    " Réserver automatiquement les employés en cas d'acceptation sans invitation",
  autoBookSelfSignInsDepartmentDefault:
    " Activer par défaut la réservation automatique des employés en cas d'acceptation sans invitation pour les départements ",
  jobMatrixHideCanceledJobs:
    'Masquer les services annulés dans la matrice de planification',
  jobMatrixForRequester:
    'Afficher la matrice de planification pour les demandeurs',
  jobMatrixCertificatePriority:
    'Priorités de qualifications pour la matrice de planification',
  jobMatrixCertificatePriorityDescription:
    'Les priorités sont considérées dans la matrice de planification de haut en bas. Les services avec plusieurs qualifications ne sont affichés que pour la priorité la plus élevée.',
  groupBy: 'Grouper par: ',
  preventDirectAcceptWithinHoursPerShift:
    'Désactiver la réservation directe dans les x heures avant le début du service (1.5 = 1 heure 30 minutes)',
  statusAfterCancelEnum: {
    AVAILABLE: 'Disponible',
    UNAVAILABLE: 'Indisponible',
    WORKING: 'En cours',
    UNKNOWN: 'Inconnu',
  },
  smsDisabledForDemo:
    "L'envoi de SMS est désactivé pour les environnements de démonstration",
  userExistsInDemo:
    'Cet utilisateur existe dans une démo, veuillez contacter le support inpool.',
  userAlreadyExists: "L'utilisateur est déjà enregistré",
  demoSetupCompleted: 'Environnement de démonstration créé avec succès',
  demoExpired: 'Votre version de démonstration a expiré',
  jobs: 'Services',
  jobsFromDate: 'Services le {{datum}}',
  assignments: 'Missions',
  logout: 'se déconnecter',
  admin: 'Admin',
  profile: 'Profil',
  tariffs: 'Tarifs',
  jobDefaults: 'Valeurs par défaut',
  customerFlags: "Paramètres d'administration",
  poolerTypes: "type d'emploi",
  dashboard: 'Tableau de bord',
  activationPending: 'Activation en attente',
  cancelReasons: "Raisons de l'annulation",
  agencyPriorities: 'Priorités des intermédiaires',
  jobRequestApproval: 'Demandes de service',
  transferList: 'Liste de transfert',
  showByTranscribedAtDate: 'Afficher par date de transcription',
  only1kTranscribeJobsShown:
    'Seuls les 1 000 services les plus récents sont affichés. Réduisez la recherche si nécessaire.',
  only1kTranscribeJobsByDateShown:
    'Seuls les 1 000 derniers services transférés sont affichés. Réduisez la recherche si nécessaire.',
  transcribedAt: 'Transcrit le',
  transcribedBy: 'Transcrit par',
  bookedInvitee: 'Employé réservé',
  noJobsToTranscribe: "Il n'y a pas de services à transférer 🎉",
  noJobsTranscribedYet: "Aucun service n'a encore été transféré",
  manualTranscribeJobListDescription: 'Aperçu des transferts de jobs manuels',
  demandReasons: 'Raison de la demande',
  requestOverview: 'matrice de planification',
  certificateGroups: 'Groupes de qualifications',
  customCriteria: 'Critères personnalisés',
  addCustomCriteriaGroup: 'Ajouter un critère personnalisé',
  customCriteriaTypeToggle: 'Interrupteur',
  customCriteriaTypeSelect: 'Liste de choix',
  defaultValue: 'Valeur par défaut',
  defaultValueForPooler: 'Valeur par défaut sur le profil',
  defaultValueForJob: 'Valeur par défaut sur le service',
  customCriteriaBlockingToggle:
    "Bloque l'intérimaire si l'intérimaire a le critère, mais le service ne l'a pas.",
  multipleSelection: 'Sélection multiple',
  addOption: 'Ajouter une option',
  customCriteriaUserEditable: 'Modifiable par l’intérimaire sur son profil',
  customCriteriaEnableOnJobRequest: 'Demander lors de la demande de mission',
  jobsPool: 'Pool de services',
  employmentsPool: 'Pool de missions temporaires',
  addTariff: 'Ajouter un tarif',
  hourlyWage: 'Tarif horaire CHF',
  addDefault: 'Ajouter un défaut',
  enablePoolerTypes: "Activer les types d'emploi",
  enableDemandReasons: 'Activer les raisons de la demande',
  prioritizeEmployeeLastName: 'Afficher le nom de famille avant le prénom',
  transferredJobsNoLongerActionRequired:
    'Afficher les services transférés sous forme de service gris',
  approvedJobRequestsNoLongerActionRequired:
    'Afficher les demandes de service approuvées sous forme de demande de service gris',
  enableCopyDateOnDuplicate: 'Copier les dates lors de la duplication',
  enableAutoDirectAccept: 'Activer les auto-Zusagen',
  preventAutoDirectAcceptWithinHours:
    'Désactiver les auto-Zusagen x heures avant le début du Dienst',
  allowIgnoreUserPreferenceDepartmentBlacklist:
    'Autoriser à ignorer la liste noire des départements des employés',
  preventChangingOfCreator: "Empêcher la modification du créateur d'un service",
  timeTrackingEnabled: 'Activer le suivi du temps',
  timeTrackingDescriptionRequiredOnChange:
    'Description requise lors de la modification du suivi du temps',
  timeTrackingAutoApproveInDays:
    'Approbation automatique du suivi du temps après X jours si non approuvé par le dispatcheur',
  timeTrackingDefaultPauseInHours: 'Pause par défaut en heures',
  enableJobRequestApproval: 'Approbation de la demande de service',
  enableCaseNumberInJobRequests:
    'Activer le numéro de cas dans les demandes de service',
  addNotification: 'Ajouter une notification',
  noNotificationsConfigured: 'Aucune notification configurée',
  addTimeRange: 'Ajouter une plage horaire',
  timeFrom: 'De',
  timeTo: 'À',
  wholeDay: 'Toute la journée',
  enableRequestOverview: 'Afficher la matrice de planification',
  enableSectionToggleInJobMatrix:
    'Activer le basculement des sections dans la matrice de planification',
  disableTimetrackingForOwnPoolers:
    'Désactiver le suivi du temps pour ses propres poolers',
  enableTimetrackingForNewOrganisationsByDefault:
    'Activer le suivi du temps pour les nouvelles organisations par défaut',
  disableApproveTimetrackingNotificationsForTransfers:
    "Désactiver les notifications d'approbation du suivi du temps pour les transferts",
  enableTranscribeJobList: 'Activer la liste de transfert de job',
  enableTranscribeJobListDescription:
    'Liste pour le transfert des réservations et annulations vers un autre logiciel',
  requestOverviewHideCanceledJobs:
    'Masquer les services annulés dans la matrice de planification',
  requestOverviewForRequester:
    'Afficher la matrice de planification pour les demandeurs',
  enableMonthlyHours: 'Afficher les heures mensuelles',
  exceptions: 'Exceptions',
  requestOverviewCertificatePriority:
    'Priorités de qualifications pour la matrice de planification',
  requestOverviewCertificatePriorityDescription:
    'Les priorités sont considérées dans la matrice de planification de haut en bas. Les services avec plusieurs qualifications ne sont affichés que pour la priorité la plus élevée.',
  addCertificatePriority: 'Ajouter une priorité de qualification',
  addPoolerType: "Ajouter un type d'emploi",
  confirmPoolerTypeDeletion:
    "Voulez-vous vraiment supprimer ce type d'emploi ? \n Il y a {{count}} employé(s) assigné(s) à ce type d'emploi.",
  addDemandReason: 'Ajouter une raison',
  enableDescriptions: 'Descriptions',
  addCancelReason: 'Ajouter une raison',
  addCertificateGroup: 'Ajouter un groupe de qualifications',
  addConditionalTransfer: 'Ajouter un transfert conditionnel',
  hoursBeforeJobStart:
    'Règle active à partir de x et heures moins avant le début du service',
  blockingHours: 'Avance',
  conditionalTransfersDescription:
    "Ici, vous pouvez définir les conditions de transfert vers les intermédiaires. Les conditions ne sont appliquées que si l'objet de service se trouve dans le temps indiqué. La première condition qui convient est toujours appliquée. Si aucune heure n'est indiquée, la condition est toujours appliquée",
  addCustomerGroup: 'Ajouter un groupe de clients',
  addConditionGroup: 'Ajouter un groupe de conditions',
  jobsTransfers: 'Transfert de pool de services ',
  employmentsTransfers: 'Transfert de pool de missions temporaire',
  sharedPool: 'Shared Pool',
  agencyPrioritiesDescription:
    'Ici, vous pouvez définir les priorités pour le transfert aux intermédiaires',
  supplier: 'Agence',
  loadingReport: 'Chargement du rapport',
  timeSpan: 'Période',
  noTimeSpanSelected: 'Aucune période sélectionnée',
  open: 'Ouvert',
  jobId: 'Job ID',
  correctionReason: 'Raison de la correction',
  dispoCorrectionReason: 'Raison de la correction (Dispo)',
  poolerCorrectionReason: 'Raison de la correction (Pooler)',
  departmentId: 'Department ID',
  perAgency: 'Par agence',
  timeTrackingReport: 'Rapport de temps',
  timeTrackingReportDescription:
    'Export du temps de travail enregistré par service',
  shiftsPlanningReport: 'Planification des services',
  jobsForInvoice: 'Services pour facturation',
  jobsForInvoiceDescription: 'Liste de tous les services pour facturation',
  shiftsPlanningReportDescription:
    'Liste de toutes les affectations réservées ou annulées pour la période sélectionnée',
  jobOverviewReport: "Vue d'ensemble des services",
  jobOverviewReportDescription:
    'Contient tous les services et tous les statuts pour la période sélectionnée.',
  activityReport: 'Inactivité',
  activityReportDescription:
    'Liste de tous les poolers inactifs pour la période sélectionnée',
  externalCancellationTime: "Heure de l'annulation externe",
  externalCancellationsDescription:
    "Vue d'ensemble de tous les services annulés par des agences externes.",
  canceledAt: 'Annulé le',
  canceledBy: 'Annulé par',
  cancelReason: "Raison de l'annulation",
  cancelReasonDescription: "Description de la raison de l'annulation",
  noAvailabilities: 'Aucune disponibilité',
  noBookings: 'Aucune réservation',
  poolerOverview: "Vue d'ensemble des poolers",
  poolerAssignmentReportDescription:
    'Affectation des poolers par service/département ou poolers avec formation',
  userAvailabilityReport: 'Disponibilité des utilisateurs',
  userAvailabilityReportDescription: 'Disponibilité des utilisateurs',
  bookedVsAvailablePercentage: 'Réservé / Disponible en %',
  availableUserJobPlanningReport: 'Planification des employés',
  availableUserJobPlanningDescription:
    "Vue d'ensemble de toutes les confirmations pour tous les services ouverts.",
  poolerReactionTime: 'Temps de réaction des poolers',
  smsUsage: 'Utilisation des SMS',
  smsUsageDescription:
    "Vue d'ensemble de tous les SMS envoyés (ne peut pas être limité aux départements)",
  poolerReactionTimeDescription:
    "Vue d'ensemble de tous les poolers et de leurs temps de réaction.",
  bookedEmployee: 'Employé réservé',
  certificatesOfBookedEmployee: "Certifications de l'employé réservé",
  desiredCertificates: 'Certifications souhaitées',
  internalDescription: 'Description interne',
  archivedJobsReport: 'Services archivés',
  archivedJobsReportDescription:
    'Tous les services archivés avec les détails des missions et des employés réservés',
  transferReport: 'Transferts',
  transferReportDescription:
    "Vue d'ensemble de tous les transferts pour la période sélectionnée",
  availabilityUpdatesReport: 'Mises à jour des disponibilités',
  availabilityUpdatesReportDescription:
    "Vue d'ensemble de toutes les modifications des disponibilités",
  internalId: 'ID interne',
  updatedAt: 'Mis à jour le',
  updatedBy: 'Mis à jour par',
  availabilityStatusEnum: {
    AVAILABLE: 'Disponible',
    UNAVAILABLE: 'Indisponible',
    WORKING: 'En cours',
  },
  disponentOverview: "Vue d'ensemble des planificateurs",
  disponentAssignmentReportDescription:
    'Aperçu de tous les planificateurs et de leurs autorisations',
  restrictedToDepartments: 'Limité aux départements',
  restrictedToCertificates: 'Qualification',
  planningMatrixReport: 'Matrice de planification',
  planningMatrixReportDescription:
    'Matrice de planification pour une répartition optimale des collaborateurs réservables. Remarque : seule la date "du" est prise en compte pour ce rapport,',
  planningMatrixReportHeaderRowTitle: 'Instructions : \n',
  planningMatrixReportHeaderRowDescription:
    'Inscrire un "b" pour l\'écriture dans la cellule correspondante.',
  hoursByDepartment: 'Heures par département',
  hoursByDepartmentDescription: "Vue d'ensemble des heures par département",
  customerConnectionsReport: 'Clients connectés',
  customerConnectionsReportDescription:
    "Vue d'ensemble de tous les clients qui sont connectés via des transferts ou des pools partagés",
  currentlyActiveEmployments: 'Employés actifs',
  currentlyActiveEmploymentsDescription:
    'Liste de tous les employés actifs pour la période sélectionnée avec leur emploi et leur charge',
  connectedViaJobs: 'via Services',
  connectedViaEmployments: 'via Temporaires',
  departmentDeselected: 'Département désélectionné',
  departmentDeselectedByPooler:
    'Ce département a été désélectionné par le pooler',
  caseNumber: 'Numéro de dossier',
  caseNumberShort: 'Num. doss.',
  costCenter: 'Centre de coûts',
  multiDayEdit: 'Modifier la série',
  waiting: 'en attente',
  invited: 'invité',
  intrested: 'Intéressé',
  notIntrested: 'Pas intéressé',
  partiallyIntrested: 'Partiellement intéressé',
  reportedAvailable: 'Signalé disponible',
  hasAvailablePeople: 'Personnes disponibles',
  restViolationsDetected: 'Temps de repos non garanti',
  pricePerHourIfNotSpecified:
    "Prix par heure (si aucun tarif fixe n'est convenu)",
  confirmIgnoreRestViolations:
    '{{violations}}\n\nVoulez-vous continuer quand même ?',
  waitingForResponse: 'En attente de réponse',
  thereAreXJobsWithOpenInvitations:
    'Il y a {{count}} services avec des confirmations en attente pour ce jour.',
  thereIsAnOpenInvitationForThisDay:
    'Il y a une confirmation en attente pour ce jour.',
  shouldCancelOpenInvitations: 'Faut-il les annuler ?',
  cancelOpenInvitations: 'Annuler les services',
  keepOpenInvitations: 'Garder les services ouverts',
  cancelOpenInvitation: 'Annuler le service',
  keepOpenInvitation: 'Garder le service ouvert',
  noOpenInvitations: 'Aucune demande ouverte',
  createNewJob: 'Nouveau service',
  nextTransferAt: 'prochain le {{date}}',
  loadingJobs: 'Chargement des services...',
  noJobsFound: 'Aucun service trouvé',
  editTimes: 'Modifier les horaires',
  editShifts: 'Modifier les services',
  criteria: 'Critères',
  readOnlyOwnerAccessHint:
    'Ce service a été créé par une agence et ne peut donc pas être modifié.',
  careSector: 'Expérience / Secteur de soins',
  accept: 'accepter',
  accepted: 'accepté',
  partialAccept: 'accepter partiellement',
  partialAccepted: 'accepté partiellement',
  answered: 'Répondu',
  partialAcceptEdit: 'Modifier les horaires partiels',
  acceptAndClose: 'accepter et fermer',
  reask: 'redemander',
  setToUnavailable: 'marquer comme indisponible',
  setToAvailable: 'marquer comme disponible',
  includeUndecided: 'Inclure les disponibilités inconnues',
  previousJobsInThisDepartmentOfLast3Months:
    'Services de la dernière période de 3 mois dans ce département / organisation',
  previousEmploymentsInThisDepartmentOfLast3Months:
    'Missions de la dernière période de 3 mois dans ce département / organisation',
  upcoming: 'à venir',
  invite: 'inviter',
  book: 'réserver',
  inviteAndBook: '{{inviteCount}} inviter et {{bookCount}} réserver',
  inviteAndSuggest: '{{inviteCount}} inviter et {{bookCount}} soumettre',
  archived: 'archivé',
  cancelJob: 'annuler le service',
  conclude: 'fermer',
  availableEmployees: 'employés disponibles',
  requestedEmployees: 'employés demandés',
  acceptedAt: 'Accepté le {{date}} ({{distance}})',
  declinedAt: 'Refusé le {{date}} ({{distance}})',
  wasDeclinedAt: 'A été refusé le {{date}} ({{distance}})',
  possibleCandidateAt: 'Candidat potentiel soumis le {{date}} ({{distance}})',
  bookedAtWithDate: 'Réservé le {{date}} ({{distance}})',
  cancelledAtWithDate: 'Annulé le {{date}} ({{distance}})',
  transcribedAtWithDate: 'Transcrit le {{date}} ({{distance}})',
  noResponseGiven: 'Le service a déjà été fermé',
  partialAcceptedAt: 'Partiellement accepté le {{date}} ({{distance}})',
  jobAlreadyOccupied: 'Ce service a malheureusement déjà été pourvu',
  jobAlreadyCanceled: 'Ce service a malheureusement déjà été annulé',
  canceled: 'Annulé',
  automatically: 'automatiquement',
  immediately: 'immédiatement',
  soon: 'bientôt',
  closeJobImmediately: 'Fermer le service immédiatement',
  bookAndClose: 'Réserver et fermer',
  transferred: 'transféré',
  transferredAt: 'transféré le {{date}} ({{distance}})',
  nextTransfer: 'prochain transfert',
  tooManyJobs:
    'Seuls les prochains {{limit}} services sont affichés. Restreignez la recherche si nécessaire.',
  saveDefaultFilter: 'Enregistrer le filtre',
  showCanceledJobs: 'Afficher les services annulés',
  onlyShowCanceledJobs: 'Afficher uniquement les services annulés',
  showOnlyActionRequiredBookableJobs:
    'Afficher uniquement les services avec une personne réservable',
  showOnlyActionRequiredNoOpenInviteesJobs:
    'Afficher uniquement les services sans invitations ouvertes',
  onyShowBookedJobs: 'Afficher uniquement les services réservés',
  icsDownload: 'Calendrier',
  activateMultipleShifts: 'Activer les services partagés',
  requiredEmployees: 'Employés requis',
  submitAsPossibleCandidate: 'Soumettre comme candidat potentiel',
  transferNow: 'Transférer maintenant',
  transferAutomatically: 'Transférer automatiquement',
  preventDirectAccept: 'Interdire la réservation directe',
  allowDirectAccept: 'Autoriser la réservation directe',
  directTransfer: 'Transférer directement',
  declineJob: 'Refuser le service',
  important: 'Important',
  confirmPoolerAvailability:
    "Vous enregistrez une acceptation de service manuelle. Veuillez confirmer que vous avez obtenu l'accord verbal préalable de l'employé pour ce service.",
  will: 'va',
  transferInvitee: "transférer l'employé",
  poolerDoesNotHaveSelectedJobType:
    "L'employé n'a pas le type de poste sélectionné dans ses types de poste sélectionnés.",
  transferInviteeDepartmentNotAssignedTitle: 'Service non affecté',
  transferInviteeDepartmentNotAssignedWarning:
    "L'employé sélectionné n'est pas affecté à ce service ou à cette unité. Souhaitez-vous quand même effectuer le transfert ?",
  transferInviteeTransferAnyway: 'Transférer quand même',
  submitEmployees: 'Soumettre les employés',
  previouslyPossibleEmployeesSection: 'Employés à soumettre à nouveau',
  previouslyPossibleEmployeesHint:
    'Après la réouverture du poste, ces employés peuvent être soumis à nouveau.',
  resubmitPreviouslyPossibleEmployee: 'Soumettre à nouveau',
  user: 'Employé',
  booked_user: 'Employé réservé',
  canceled_user: 'Employés annulés',
  shiftStart: 'Début du service',
  shiftEnd: 'Fin du service',
  confirmPoolerWithNotes:
    'La personne que vous souhaitez réserver a les notes suivantes : ',
  onlyAvailableEnd: ' disponible',
  userPartiallyAcceptedForTime:
    "L'employé a partiellement accepté pour l'heure indiquée",
  confirmManyInvites: 'Voulez-vous vraiment envoyer plus de 50 invitations ?',
  addToField: "Ajouter jusqu'à",
  removeToField: "Supprimer jusqu'à",
  restNotGuaranteed: 'Temps de repos non garanti',
  unknownAvailability: 'Disponibilité inconnue',
  unknown: 'Inconnue',
  hasNote: 'Note présente',
  note: 'Note',
  restTime: 'Temps de repos',
  deselectAllEmployees: 'Désélectionner tous les employés',
  selectAllEmployees: 'Sélectionner tous les employés',
  inviteXOfYPeople: 'Inviter {{count}} employés',
  bookXPeopleDirectly: 'Réserver immédiatement {{count}} employés',
  addAnotherDate: 'Ajouter une autre date',
  confirmJobAcceptAvailablePoolerPre: 'Voulez-vous postuler pour le service du',
  confirmJobAcceptAvailablePoolerPost: ' ?',
  confirmJobAcceptUnavailablePoolerPre:
    'Assurez-vous que vous êtes disponible le',
  confirmJobAcceptUnavailablePoolerPost:
    ' . Voulez-vous postuler pour ce service ?',
  confirmAutoBookInviteeAcceptJob:
    'La réservation est obligatoire et ne peut plus être modifiée.',
  repeatingJob: 'Service récurrent',
  createJobs: 'Créer {{count}} services',
  editShiftTimes: 'Modifier les horaires de service',
  transferNowPre: 'Voulez-vous transférer ce service immédiatement à',
  transferNowAll: 'toutes les agences',
  transferNowPost: ' ?',
  transferToAll: 'Tout transférer',
  automaticallyAt: 'automatiquement le {{date}} ({{distance}})',
  automaticallyAfterBlocked:
    'automatiquement après la période de blocage en ({{distance}})',
  blockedUntil: "Bloqué jusqu'au : ",
  automaticallyImmediately: 'automatiquement immédiatement',
  declineReason: 'Raison du refus',
  jobInPastWarning: {
    '0': 'Ce service est dans le passé. Veuillez noter :',
    '1': "Les employés ne peuvent être réservés qu'immédiatement",
    '2': 'Aucune notification ne sera envoyée',
    '3': 'Les disponibilités ne seront pas prises en compte',
  },
  confirmTransferReject: 'Voulez-vous vraiment refuser le service ?',
  workTime: 'Temps de travail',
  checkHours: 'Vérifier les heures',
  recordHours: 'Enregistrer les heures',
  requiredUsersAmount: 'Nombre de personnes nécessaires',
  deleteConfirmTitle: 'Supprimer le dossier ?',
  deleteConfirmContent:
    'Le dossier sera supprimé et ne pourra pas être récupéré',
  internalInformation: 'Informations internes',
  internalInformationSubline:
    'Diese Informationen sind nur für {{customerName}} sichtbar und werden bei einem Transfer nicht mitgesendet',
  internalPoolers: 'employés internes',
  bookedInvitees: 'Invités réservés',
  transfers: 'Transferts',
  internalNote: 'Note interne',
  createdAt: 'Créé le',
  closedJobTooltip: 'Réservé le {{date}} ({{distance}})',
  transfersTooltip: 'Transféré / Total des transferts possibles',
  declinedTransfersTooltip: 'transferts refusés',
  activeAutoTransfersTooltip: 'transferts automatiques actifs',
  requests: 'Demandes',
  bookedServices: 'Services réservés',
  archivedServices: 'Services archivés',
  hideAllRequests: 'Masquer toutes les demandes',
  monthlyWorkingHoursTooltip:
    '{{percentage}}% | {{current}}/{{total}} heures réservées ce mois',
  assignment: 'Mission',
  employment: 'Mission',
  createNewEmployment: 'Nouvelle mission',
  availabilityNotes: 'Notes de disponibilité',
  availabilityNoteFormat: '{{start}} à {{end}} : {{note}}',
  possibleCandidates: 'Candidat potentiel',
  showHistory: "Afficher l'historique",
  inviteAndCreate: 'Inviter et créer',
  inviteAndSave: 'Inviter et enregistrer',
  cancelEmployment: 'Annuler la mission',
  showCanceledEmployments: 'Afficher les missions annulées',
  tooManyEmployments:
    'Seuls les prochains {{limit}} missions sont affichées. Restreignez la recherche si nécessaire.',
  foundOtherPersonnel: 'La mission a déjà été pourvue',
  creationMistake: 'Erreur de création de la mission',
  notNeededAnymore: "La mission n'est plus nécessaire",
  otherReason: 'Autre raison',
  employmentHasBeenOccupied: 'Cette mission a malheureusement déjà été pourvue',
  match: 'Correspondance',
  addAvailabilityField: 'Ajouter un champ de disponibilité',
  removeAvailabilityField: 'Supprimer un champ de disponibilité',
  qualifications: 'Qualifications',
  noEmployeesSubmitted: 'Aucun employé soumis',
  declineEmployment: 'Refuser la mission',
  deleteFileConfirmTitle: 'Supprimer le dossier ?',
  deleteFileConfirmContent:
    'Le dossier sera supprimé et ne pourra pas être récupéré',
  initialStartDate: 'Date de début initiale',
  initialEndDate: 'Date de fin initiale',
  initialWorkload: 'charge de travail initiale',
  transferConfirmationText:
    'Voulez-vous vraiment finaliser les heures ? Elles ne pourront plus être modifiées par la suite.',
  submitConfirmationText:
    'Voulez-vous vraiment approuver les heures ? Elles ne pourront plus être modifiées par la suite.',
  invalidBreakTime: 'Pause non valide',
  submitTimeTracking: 'Soumettre les heures',
  approveHours: 'Approuver les heures',
  bookDirectly: 'réserver immédiatement',
  suggestDirectly: 'soumettre immédiatement',
  suggest: 'soumettre',
  personalInfoHelpText: 'Sexe et nom',
  weNeedSomeData:
    'Nous avons besoin de quelques informations supplémentaires de votre part',
  confirmEmail: "Confirmer l'adresse e-mail",
  pleaseConfirmEmail:
    'Veuillez confirmer la nouvelle adresse e-mail en cliquant sur le lien de confirmation que nous vous avons envoyé',
  resendSmsCode: 'Renvoyer le code SMS',
  resendConfirmationEmail: "Renvoyer l'e-mail de confirmation",
  smsConfirmationCode: 'Code de confirmation SMS',
  mobilePhoneExample: 'Numéro de portable (p. ex. +33791234567)',
  mobilePhoneNumber: 'Numéro de portable',
  notShowingAllUsers:
    "Seuls {{count}} employés sont affichés. Utilisez le champ de recherche pour voir d'autres employés.",
  cancelBookedInvitee: "Annuler l'employé réservé",
  reason: 'Raison',
  declineInvitee: "Refuser l'employé",
  availabilityNote: 'Note sur la disponibilité',
  noRest:
    "L'utilisateur sélectionné ne pourra pas respecter le temps de repos pour ce service.",
  createEmployment: 'Créer une mission',
  shiftsLongName: {
    EARLY: 'Service du matin',
    DAY: 'Service de jour',
    LATE: 'Service du soir',
    NIGHT: 'Service de nuit',
  },
  calendarWeek: 'Sem',
  selectedShiftsHint:
    'Voici vos services déclarés comme disponibles. Vous pouvez définir les services par défaut dans les paramètres.',
  inviteXUsers: 'Inviter {{count}}',
  bookXUsers: 'Réserver {{count}}',
  dateRangeChips: {
    ALL: 'Tous',
    TODAY: "Aujourd'hui",
    TOMORROW: 'Demain',
    WEEK: 'Cette semaine',
    NEXT_WEEK: 'La semaine prochaine',
    MONTH: 'Ce mois-ci',
    NEXT_MONTH: 'Le mois prochain',
    CUSTOM: 'Période',
    N30: '+30 jours',
    N90: '+90 jours',
    L30N30: '-30, +30 jours',
    L90: '-90 jours',
  },
  bookedForShift: {
    EARLY: 'réservé pour le service du matin',
    DAY: 'réservé pour le service de jour',
    LATE: 'réservé pour le service du soir',
    NIGHT: 'réservé pour le service de nuit',
  },
  editNote: 'Modifier la note',
  addNote: 'Ajouter une note',
  myAvailabilities: 'Mes disponibilités',
  myDepartments: 'Mes départements',
  otherEmployeesAvailable:
    '{{date}} {{shiftLabel}}: {{count}} Autres employés disponibles',
  addUser: 'Ajouter un utilisateur',
  active: 'actif',
  registered: 'inscrit',
  former: 'ancien',
  type: 'Type',
  notes: 'Notes',
  notesPlaceholder:
    'Spécial p. ex. Libre le week-end ou libre à une date spécifique',
  unavailabilityReason: "Raison de l'absence",
  unavailabilityReasonEnum: {
    HOLIDAY: 'Vacances',
    SICK: 'Maladie',
    TRAINING: 'Formation',
    OTHER: 'Autre',
  },
  editAvailability: 'Modifier la disponibilité',
  otherOrganisation: 'Autre organisation',
  availabilitySelectionWarning: 'Attention : Informations complémentaires',
  availabilitySelectionWarningText:
    'Il y a des informations supplémentaires sur cette disponibilité. Veuillez vérifier ceci.',
  restWarning: 'Temps de repos non garanti',
  inviteAgain: 'Inviter à nouveau',
  restWarningLong:
    "Le temps de repos de 11 heures n'est pas garanti. Veuillez vérifier manuellement.",
  unlock: 'Déverrouiller',
  nextShiftStart: 'Prochain service commence le :',
  lastShiftEnd: 'Dernier service se termine le :',
  downloadDossier: 'Télécharger le dossier',
  removeFromPool: 'Retirer {{ name }} du pool ?',
  impersonate: "Se connecter en tant qu'utilisateur",
  impersonateUser: 'Se connecter en tant que {{ name }} ?',
  returnToUser: "retour à l'utilisateur",
  loadingProfile: 'Profile is loading',
  editingRequestedUserHint:
    "Toutes les informations ne sont pas disponibles car l'utilisateur n'a pas encore accepté la demande de collaboration.",
  contactSettings: 'Paramètres de contact',
  getNotificationSms: 'Recevoir des notifications par SMS',
  getNotificationEmail: 'Recevoir des notifications par e-mail',
  getNotificationPush: 'Recevoir des notifications par Push',
  twoFactorAuthEnabled: 'Authentification à deux facteurs activée',
  allowPushNotifications: 'Autoriser les notifications Push pour ce site',
  enableJobs: 'Activer le pool de services',
  enableEmployments: 'Activer le pool de missions temporaires',
  getOwnJobConfirmations:
    'Recevoir des confirmations de réservation pour ses propres services',
  disableUnsavedChangesWarning:
    "Désactiver l'avertissement des modifications non enregistrées",
  disabledEmails: 'E-mails désactivés',
  creatorNotifications: {
    ACCEPTED_TIME_TRACKING: 'Suivi du temps accepté',
    ACTION_REQUIRED_ACCEPT_INVITEE:
      "Action requise pour le service - Accepter l'employé",
    ACTION_REQUIRED: 'Action requise pour le service',
    APPROVE_TIME_TRACKING_FOR_CREATOR: 'Approuver le suivi du temps',
    APPROVE_TIME_TRACKING_REMINDER_FOR_CREATOR:
      'Rappel – approuver le suivi du temps',
    BOOKED_INTERNAL: 'Service réservé (pool interne)',
    BOOKED_EXTERNAL: 'Service réservé (pool externe)',
    POSSIBLE_CANDIDATE: 'Candidat potentiel (service)',
    INVITEE_CANCELED: "Annulation par l'employé réservé (service)",
    JOB_CANCELED: 'Service annulé',
    TRANSFER_DECLINED: 'Transfert refusé (service)',
    INVITEE_REPLACED: 'Employé remplacé',
    EMPLOYMENT_BOOKED_INTERNAL: 'Mission réservée (pool interne)',
    EMPLOYMENT_BOOKED_EXTERNAL: 'Mission réservée (pool externe)',
    EMPLOYMENT_INVITEE_CANCELED: "Annulation par l'employé réservé (mission)",
    EMPLOYMENT_ACTION_REQUIRED_ACCEPT_INVITEE:
      "Action requise pour la mission - Accepter l'employé",
    EMPLOYMENT_ACTION_REQUIRED: 'Action requise pour la mission',
    EMPLOYMENT_CANCELED: 'Mission annulée',
    EMPLOYMENT_INFORMATION_CHANGED: 'Informations de mission modifiées',
    EMPLOYMENT_POSSIBLE_CANDIDATE: 'Candidat potentiel (mission)',
    EMPLOYMENT_TRANSFER_DECLINED: 'Transfert refusé (mission)',
    JOB_REQUEST_ACCEPTED: 'Demande de service acceptée',
    JOB_REQUEST_DECLINED: 'Demande de service refusée',
    JOB_RETRACTION_REQUEST_ACCEPTED: 'Demande de retrait du service acceptée',
    JOB_RETRACTION_REQUEST_DECLINED: 'Demande de retrait du service refusée',
  },
  noNotificationSelected:
    "Si aucune des deux options ou Push n'est activée, vous ne serez pas automatiquement informé des nouvelles demandes de service.",
  noShiftSelected:
    "Si aucun service n'est activé, vous ne recevrez pas de demandes de service.",
  qualificationsProfileEditText:
    'Ces informations ne peuvent pas être modifiées par vous-même. Si elles ne sont pas correctes, veuillez contacter votre employeur.',
  jobSettings: 'Paramètres du service',
  weWillContactYouAboutActivation:
    "Merci d'avoir soumis vos documents. Nous vous contacterons sous un jour ouvrable.",
  submitDocuments: 'Soumettre des documents',
  showOnlySelected: 'Afficher uniquement les départements sélectionnés',
  disabledByPooler: "désactivé par l'employé",
  blacklistedByDepartment: 'bloqué par le département',
  EARLY: 'Service du matin',
  DAY: 'Service de jour',
  LATE: 'Service du soir',
  NIGHT: 'Service de nuit',
  yourEmailWasSetTo: 'Votre adresse e-mail a été définie sur',
  wasChangedAt: 'modifiée le',
  yourPhoneWasSetTo: 'Votre numéro de téléphone a été défini sur',
  notConnected: 'Non connecté',
  loginSystems: 'Connexions',
  additionalInformation: 'Informations supplémentaires',
  itKnowledge: 'Connaissances en informatique',
  clothingSize: 'Taille de vêtements',
  height: 'Taille',
  fileUploadInfo: 'Déposez un dossier ici ou cliquez',
  yourDocuments: 'Vos documents',
  uploadedDocuments: 'Documents disponibles',
  pleaseUploadFollowingFilesForUnlock:
    'Veuillez nous fournir les documents suivants (si disponibles), afin que nous puissions débloquer votre compte dès que possible',
  curriculumVitae: 'Curriculum Vitae',
  graduations: 'Diplômes',
  addGraduations: 'Ajouter un diplôme',
  jobReferences: 'Références de travail',
  carLicenceOptional: 'Permis de conduire (optionnel)',
  permitsBGC: 'Permis (B / C / G)',
  defaultShiftsHint: 'Les services sélectionnés seront respectés par défaut',
  defaultJobTypesHint:
    'Les types de services sélectionnés seront respectés par défaut',
  noJobTypeSelected:
    "Si aucun type de service n'est activé, vous ne recevrez pas de demandes de service.",
  canCreateDispoUsers: 'Peut créer des planificateurs',
  canCreatePooler: 'Peut créer des poolers',
  uploadDossier: 'Télécharger un dossier',
  manage: 'gérer',
  read: 'lire',
  see: 'voir',
  update: 'modifier',
  delete: 'supprimer',
  canPooler: 'peut gérer les poolers',
  canPermission: 'Peut gérer les autorisations',
  canManageTranscribeJobList: 'Peut gérer la liste des jobs de transcription',
  canTransfers: 'Peut transférer des services & réserver des propositions',
  canSharedPool: 'Peut réserver directement des poolers externes (SharedPool)',
  canTariffAdmin: 'A un accès administrateur aux tarifs',
  canEditAssignmentDefaults:
    'Peut modifier les valeurs par défaut des missions',
  canCustomerAdmin: 'Peut gérer les paramètres administratifs',
  canDispos: 'peut gérer les planificateurs',
  canJobAccess: 'peut gérer pool de services',
  canEmploymentAccess: 'peut gérer pool de missions temporaires',
  canRequester: 'peut gérer Chef de service',
  canRequestsAccess: 'Peut voir les demandes',
  canApproveJobRequests: 'Peut approuver les demandes de service',
  canApproveHours: 'Peut approuver les heures',
  joinDate: "Date d'entrée",
  leaveDate: 'Date de sortie',
  ccEmailHint: 'Veuillez entrer les adresses e-mail séparées par des virgules.',
  permissions: 'Autorisations',
  adminPermissions: 'Autorisations administratives',
  car: 'Mobilité',
  dateOfBirth: 'Date de naissance',
  location: 'Lieu de résidence',
  zip: 'Code postal',
  departmentAccess: 'Accès aux départements',
  checkOwnAvailability: 'Tenir compte de ma disponibilité',
  poolRequestTitle: 'Demande de collaboration',
  poolRequestText:
    "veut vous ajouter à son pool. Autoriser l'accès à votre profil et à vos disponibilités et recevoir des demandes de service ?",
  dispoRequestTitle: 'Invitation en tant que répartiteur',
  dispoRequestText:
    "souhaite vous ajouter comme répartiteur. Voulez-vous accepter l'invitation ?",
  organisationRequestTitle: 'Nouveau lieu de mission',
  organisationRequestText:
    "Souhaitez-vous recevoir des demandes de service pour ce lieu de mission à l'avenir ?",
  moreLink: 'vers le site web',
  openJobs: 'Services ouverts',
  newestRequests: 'Nouvelles demandes',
  possibleJobs: 'Services possibles',
  noMatchingEmployments: 'Aucune mission correspondante trouvée',
  noMatchingJobs: 'Aucun service correspondant trouvé',
  matchingOffers: 'Offres correspondantes',
  possibleEmployments: 'Missions possibles',
  nextJob: 'Prochain service',
  actionRequiringJobs: 'Services nécessitant une action',
  nextEmployment: 'Prochaine mission',
  pendingTimetrackingJobs: 'Suivi du temps en attente',
  noJobFound: 'Aucun service trouvé',
  noEmploymentFound: 'Aucune mission trouvée',
  showAllJobs: 'Afficher tous les services',
  showAllEmployments: 'Afficher toutes les missions',
  userWasInvited: "L'utilisateur a été invité.",
  userWasReasked: "L'utilisateur a été redemandé.",
  jobReopenedInviteNotificationSent:
    "Une nouvelle demande a été envoyée à l'utilisateur après la réouverture du service.",
  jobReminderSent: 'Rappel du service envoyé',
  inviteReminderSent: "Rappel de l'invitation envoyé",
  userHasAccepted: "L'utilisateur a accepté.",
  userHasDeclined: "L'utilisateur a refusé.",
  userHasPartiallyAccepted: "L'utilisateur a partiellement accepté.",
  userHasEditedPartialTimes:
    "L'utilisateur a modifié les horaires partiellement acceptés.",
  userWasAccepted: "L'utilisateur a été réservé.",
  userWasSubmittedAsPossibleCandidate:
    "L'utilisateur a été soumis comme candidat potentiel",
  userWasTransferredFrom: "L'utilisateur a été transféré de",
  userWasTransferredTo: "L'utilisateur a été transféré à",
  userWasDeclined: "L'utilisateur a été refusé.",
  userBookedOnAnotherJob: "L'utilisateur a été réservé pour un autre service.",
  userAvailableBecauseJobCancelled:
    "L'utilisateur est de nouveau disponible, car un autre service a été annulé.",
  userSetToAvailable:
    "L'utilisateur a été marqué comme disponible par un planificateur.",
  userSetToUnavailable:
    "L'utilisateur a été marqué comme non disponible par un planificateur.",
  userWasCancelled: "L'utilisateur a été annulé.",
  invitedByCategory: "L'utilisateur a été invité par {{category}}.",
  acceptedByCategory: "L'utilisateur a été réservé par {{category}}.",
  cancelledByCategory: "L'utilisateur a été annulé par {{category}}.",
  declinedByCategory: "L'utilisateur a été refusé par {{category}}.",
  reAskedByCategory: "L'utilisateur a été redemandé par {{category}}.",
  userSubmittedAsPossibleCandidate:
    "L'utilisateur a été soumis comme candidat potentiel",
  userSelfSignIn: "L'utilisateur s'est inscrit de lui-même pour ce service",
  userSelfSignInWithAvailability:
    "L'utilisateur s'est inscrit de lui-même pour ce service et a été marqué comme disponible",
  userSelfSignInWithoutAvailability:
    "L'utilisateur s'est inscrit de lui-même pour ce service et a été marqué comme non disponible",
  userSelfSignInHasDeclined:
    "L'utilisateur s'est inscrit de lui-même et a refusé.",
  userWasReplaced: "L'utilisateur a été remplacé par un autre pooler.",
  oClock: 'heure',
  by: 'par',
  history: 'Historique',
  toOldJob: "Vers l'ancien service",
  toNewJob: 'Vers le nouveau service',
  userReportedForSelfSignIn:
    "L'utilisateur s'est inscrit de lui-même pour le service",
  requestShift: 'Demander une équipe',
  approve: 'Approuver',
  sendXRequests: 'Envoyer {{count}} demandes',
  retract: 'retirer',
  requestRetraction: 'Demander le retrait',
  jobRequestRequestRetraction: 'Retrait demandé',
  requestRetractionRequestedAt:
    'Retrait demandé par {{firstName}} {{lastName}} le {{date}}',
  approveRetractionOnRequest: 'Retrait approuvé',
  rejectRetractionOnRequest: 'Retrait refusé',
  requestOpenedAt: 'demande envoyée le {{date}}',
  requestApprovedAt: 'Accepté le {{date}}',
  requestApprovedAtBy: 'Accepté le {{date}} par {{name}}',
  requestRejectedAt: 'Demande refusée le {{date}}',
  requestRejectedAtBy: 'Demande refusée le {{date}} par {{name}}',
  requestBookedAt: 'Réservé le {{date}}',
  requestArchivedAt: 'Demande archivée le {{date}}',
  requestCanceledAt: 'Annulé le {{date}}',
  requestRetractedAt: 'Demande retirée le {{date}}',
  noActiveDepartment: 'Veuillez sélectionner un département',
  noOpenJobRequests: 'Aucune demande de service ouverte',
  pastJobs: 'Services passés',
  pastThreeMonthsDescription: 'au cours des 3 derniers mois',
  in: 'dans',
  worked: 'travaillé',
  moreThanThreeMonthsDescription: 'Il y a plus de 3 mois',
  noPastJobs: 'Aucun service passé',
  planningMatrix: 'matrice de planning',
  noOpenJobs: 'Aucun service ouvert',
  clearAllFilters: 'Supprimer les filtres',
  support: 'Support',
  supportTextUniversaljob:
    "Si tu as des questions ou des problèmes, n'hésite pas à contacter ton/ta conseiller/ère en recrutement ou à envoyer un e-mail à :",
  supportText: "En cas de problèmes, n'hésitez pas à contacter le support :",
  supportTextNotLoggedIn:
    "Si vous avez des questions ou des problèmes, n'hésitez pas à contacter votre employeur ou à nous contacter par courrier électronique.",
  downloadGuideTextInformal: 'Vous pouvez télécharger notre guide ici :',
  downloadGuideTextFormal: 'Vous pouvez télécharger notre guide ici :',
  downloadGuideTextForPooler:
    'Vous pouvez télécharger notre guide pour les employés ici :',
  downloadGuideTextForRequester:
    'Vous pouvez télécharger notre guide pour les chef de service ici :',
  phoneContactOutsideOpeningHours:
    "En dehors de nos heures d'ouverture, vous pouvez nous joindre par téléphone au",
  supportTextPooler:
    "Si vous avez des questions ou des problèmes, n'hésitez pas à contacter votre employeur.",
  supportTextRequester:
    "Si vous avez des questions ou des problèmes, n'hésitez pas à contacter votre employeur.",
  deleteProfileText:
    'Si vous souhaitez supprimer votre compte, veuillez nous contacter par courrier électronique.',
  deleteProfileTextNotLoggedIn:
    'Si vous souhaitez supprimer votre compte, veuillez nous contacter par courrier électronique.',
  workDays: 'Du lundi au vendredi',
  title: 'Titre',
  welcomeTextDemoRegistration:
    'Bienvenue dans la démo inpool. Vous pouvez configurer votre environnement de démo individuel en quelques étapes seulement, puis tester inpool gratuitement.',
  startButton: 'Commencer',
  configureDemoTitle: 'Configurer la Démo',
  isAgencyQuestion: 'Êtes-vous une agence de personnel ?',
  organizationNameLabel: 'Quel est le nom de votre organisation ?',
  monthlyServicesLabel: 'Combien de services réserverez-vous par mois ?',
  demoOrganisationType: {
    AGENCY: 'Agence de personnel',
    HOSPITAL: 'Hôpital / Clinique',
    PSYCHIATRY: 'Psychiatrie',
    LONGTERM_CARE: 'Soins de longue durée',
    SPITEX: 'Soins à domicile',
  },
  submitButton: "C'est parti",
  generatingTitle: 'La démo est en cours de configuration',
  generatingText:
    'Nous créons maintenant votre environnement de démo, veuillez patienter...',
  redirectingToDashboard: 'Vous allez être redirigé vers le tableau de bord...',
  fillAllFields: 'Veuillez remplir tous les champs',
  loadingSteps: {
    creatingOrganization: "L'organisation est en cours de création",
    generatingEmployees: 'Les employés sont en cours de génération',
    generatingOpenJobs: 'Les services ouverts sont en cours de génération',
    generatingArchivedJobs: 'Les services archivés sont en cours de génération',
  },
  welcomeTitle: 'Hourra, vous avez réussi...',
  welcomeTextDemoUserSetup: 'La démo est maintenant configurée.',
  welcomeTextDemoUserSetup2:
    "Pour que vous puissiez vous reconnecter à l'avenir et que vos paramètres ne soient pas perdus, nous allons d'abord créer ensemble un compte utilisateur pour vous.",
  welcomeTextDemoUserSetup3: 'Cliquez sur "Continuer" quand vous êtes prêt.',
  userFormTitle: 'Créer un Utilisateur',
  businessEmailLabel: 'E-mail Professionnel',
  submitUserButton: 'Créer un Utilisateur',
  confirmEmailTitle: "Confirmer l'E-mail",
  confirmEmailText: 'Merci pour vos informations.',
  confirmEmailText2:
    'Nous avons envoyé un e-mail à votre adresse e-mail <b>{{email}}</b>.',
  confirmEmailText3:
    "Veuillez cliquer sur le lien dans l'e-mail pour définir votre mot de passe.",
  confirmEmailText4:
    'Cette fenêtre se fermera automatiquement une fois la configuration de votre compte utilisateur terminée.',
  checkYourData: 'Veuillez vérifier vos informations',
  demoEmailExistsAlreadyError:
    'Un utilisateur avec l\'adresse e-mail "{{email}}" existe déjà. Pour vous connecter avec cet utilisateur, sélectionnez "Annuler" pour accéder à la page de connexion. Si vous ne connaissez plus votre mot de passe, vous pouvez y entrer votre adresse e-mail puis utiliser la fonction "Mot de passe oublié".',
  invalidEmail: 'Veuillez saisir une adresse e-mail valide',
  demoDurationHint:
    "Cette démo est valide jusqu'au {{validUntil}} ({{remainingDays}} jours restants)",
  demoExpiredTodayHint: "Cette démo a expiré aujourd'hui ({{expiredAt}})",
  demoExpiredHint:
    'Cette démo a expiré le {{expiredAt}} (il y a {{daysAgo}} jours)',
  extendDurationTitle: 'Prolonger la Durée de la Démo',
  extendDurationDescription:
    "Sélectionnez une nouvelle date d'expiration pour cette démo.",
  newValidUntilDate: "Nouvelle date d'expiration",
  disableDemo: 'Désactiver la Démo',
  deleteDemo: 'Supprimer la Démo',
  switchToLive: 'Passer en Direct',
  disableDemoTitle: 'Désactiver la Démo ?',
  disableDemoMessage: "Cela définira la date d'expiration à aujourd'hui.",
  deleteDemoTitle: 'Supprimer la Démo ?',
  deleteDemoMessage:
    'Voulez-vous vraiment supprimer la démo {{name}} ? Cela supprimera définitivement toutes les données de la démo.',
  customerName: 'Nom du Client',
  switchToLiveTitle: 'Passer au Client Direct ?',
  switchToLiveMessage: 'Cela convertira ce client de démo en client direct.',
  generatedDataWillBeDeleted: 'Toutes les données générées seront supprimées.',
  deleteOptions: 'Options de Suppression',
  deleteManuallyCreatedJobs: 'Supprimer les services créés manuellement',
  deleteManuallyCreatedPoolers: 'Supprimer les employés créés manuellement',
  deleteManuallyCreatedDispos: 'Supprimer les répartiteurs créés manuellement',
  deleteManuallyCreatedEmployments: 'Supprimer les emplois créés manuellement',
  confirmSwitchToLiveTitle: 'Confirmer le Passage au Client Direct',
  confirmSwitchToLiveMessage:
    'Voulez-vous vraiment faire de {{name}} un client direct ? Cette action ne peut pas être annulée.',
  durationExtended: 'Durée de la démo prolongée avec succès',
  demoDisabled: 'Démo désactivée avec succès',
  demoDeleted: 'Démo supprimée avec succès',
  switchedToLive: 'Passage au client direct réussi',
  errorExtendingDuration:
    'Erreur lors de la prolongation de la durée de la démo',
  errorDisablingDemo: 'Erreur lors de la désactivation de la démo',
  errorDeletingDemo: 'Erreur lors de la suppression de la démo',
  errorSwitchingToLive: 'Erreur lors du passage au client direct',
  poolerTypeBookingWarningDefaultMessage:
    "Êtes-vous sûr de vouloir réserver l'employé du type d'emploi {{poolerType}} pour le service?",
  bookingWarningEnabled: 'Activer la mise en garde de réservation',
  bookingWarningMessage: 'Mise en garde de réservation',
  bookingWarningTitle:
    'Avertissement de réservation pour {{firstName}} {{lastName}}',
  enableTimeTrackingSigninProcess:
    'Activer la signature pour le suivi du temps',
  autoAddTimeTrackingHours:
    'Heures par défaut soumettre automatiquement après X heures si non saisies par le pooler',
  requestSignature: 'Demander une signature',
  requestSignatureIntro:
    'Veuillez vous adresser à la personne responsable du service et lui remettre votre appareil pour la signature numérique de vos heures.',
  requestSignatureIntroDetails:
    'Si vous n’avez pas la possibilité de remettre physiquement votre appareil, vos heures seront automatiquement envoyées par e-mail après l’échéance.',
  handOverDevice: 'Veuillez remettre votre appareil maintenant',
  checkHoursDescription:
    'Veuillez vérifier et corriger les heures de travail de {{name}} si nécessaire.',
  signHours: 'Signer les heures',
  signHoursDescription:
    'Veuillez saisir votre nom et confirmer les heures par votre signature.',
  signHere: 'Signez ici',
  clear: 'Effacer',
  signatureRequired: 'La signature est obligatoire',
  timeTrackingConfirmation: 'Merci',
  timeTrackingConfirmationDescription:
    'Nous avons bien reçu l’approbation des heures. Vous pouvez maintenant <b>rendre</b> l’appareil.',
  sign: 'Signer',
  timeRemaining: 'restant',
  timerExpired: 'Délai expiré',
  timerExpiredDescription:
    'Le délai est expiré. Vos heures ont été envoyées par e-mail pour approbation.',
  bookingWebHookTitle: 'Webhook de réservation',
  bookingWebHookDescription:
    'Le webhook de réservation est utilisé lorsque des employés du Pool de services sont réservés ou annulés.',
  bookingWebHookUrl: 'URL du webhook',
  bookingWebHookApiKey: 'Clé API',
  bookingWebHookApiKeyCurrent: 'Actuel:',
  bookingWebHookApiKeyLeaveEmpty: 'laisser vide pour conserver inchangé',
  carePeoplePoolerBookingFailed:
    'Employé ne peut pas être réservé par CarePeople',
  vokusPoolerBookingFailed:
    'Employé ne peut pas être réservé par Vokus',
  enablePerigonApi: "Activer l'API Perigon",
  perigonTaskId: 'ID de la tâche Perigon',
  perigonId: 'ID Perigon',
  addPerigonShiftMapping: 'Ajouter une correspondance de poste Perigon',
  perigonMapping: 'Correspondances Perigon',
  perigonMappingIncompleteAt: 'Correspondance Perigon incomplète depuis',
  perigonMappingIncomplete: 'Correspondance Perigon incomplète',
  showUnmappedJobs:
    'Afficher uniquement les services sans correspondance Perigon',
  timeTrackingEnabledByOwnerTooltip: "Activé par l'organisation",
  timeTrackingDefaultPause:
    'Pause standard en heures (si non définie sur la période)',
  timeTrackingDefaultPauseByDepartment: 'Pause standard par période',
  default: 'Standard',
  sharedPoolAllowUndecided:
    "Afficher l'indisponibilité inconnue dans le Pool partagé comme option",
  disableTimetrackingForNewOrganisationsByDefault:
    'Désactiver le suivi du temps pour les nouvelles organisations par défaut',
  instructions: 'Instructions',
  noEmploymentsFound: 'Aucun emploi trouvé',
  showOnlyUnapprovedHours: 'Afficher uniquement les heures non approuvées',
  allowExternalPoolers: 'Prendre en compte le personnel externe',
  disableDispoFilterSave: "Désactiver l'enregistrement du filtre dispo",
  requiredPause: 'Pause requise en heures entre deux services',
  wardManagement: 'Gestion des services',
  conditionalTransfers: 'Transferts conditionnels',
  transfersConfirmed: 'Transferts confirmés',
  transferConfirmationPerson: 'Personne de confirmation',
  enableDescription: 'Activer la description',
  statusAfterCancel: {
    AVAILABLE: 'Disponible',
    UNAVAILABLE: 'Non disponible',
    WORKING: 'En travail',
    UNKNOWN: 'Inconnu',
  },
  requestersCanAccessReports: 'Les demandeurs peuvent accéder aux rapports',
  requestersCanAccessJobOverviewReport:
    "Les demandeurs peuvent accéder au rapport de vue d'ensemble des services",
  perigonBearerToken: 'Clé API Perigon',
  perigonClientId: 'ID Client Perigon',
  addPerigonTaskMapping: 'Ajouter une correspondance de tâche Perigon',
  loadingEmployments: 'Chargement des missions...',
  perigonMappingIncompleteDescription:
    'La correspondance Perigon est incomplète. Veuillez vérifier et corriger la correspondance Perigon.',
  archiveAtType: "Moment de l'archivage",
  archiveAtTypeEnum: {
    START_OF_JOB: 'Début du service',
    END_OF_JOB: 'Fin du service',
  },
  archiveAtOffset: "Décalage de l'archivage en minutes",
  confirmSaveCustomerFlags:
    'Voulez-vous vraiment enregistrer les paramètres administrateur ? Cela peut avoir une influence sur les services déjà saisis.',
  archiveAtOffsetDescriptionStartOfJob:
    'Exemple: Service commençant à 7:00 sera archivé à {{timeStamp}}.',
  archiveAtOffsetDescriptionEndOfJob:
    'Exemple: Service finissant à 16:00 sera archivé à {{timeStamp}}.',
  timeTrackingSettings: 'Paramètres de suivi du temps',
  reject: 'Refuser',
  elevenHourWarning:
    "La période de repos de 11 heures n'est pas garantie. Veuillez vérifier le temps de repos.",
  sevenDayWarning:
    "La période de repos de 83 heures après 7 jours n'est pas garantie. Veuillez vérifier le temps de repos.",
  potentialSevenDayWarningWithInfraction:
    'La période de repos de 83 heures après 7 jours ne peut pas être garantie si ce service est réservé. Veuillez vérifier le temps de repos.',
  potentialSevenDayWarning:
    'En réservant ce service, une séquence de 7 jours consécutifs sera créée.',
  reportEnabledInOverview: "Afficher le rapport dans la vue d'ensemble",
  adminReportsAllDisabledWarning:
    "Tous les rapports sont masqués. Les utilisateurs ne verront plus aucun téléchargement dans la vue d'ensemble des rapports.",
  reportsEnum: {
    JOBS_FOR_INVOICE: 'Services pour facture',
    CURRENTLY_ACTIVE_EMPLOYMENTS: 'Missions temporaires en cours',
    EXTERNAL_CANCELLATIONS: "Horodatage d'annulation du personnel externe",
    ACTIVITY: 'Inactivité',
    TIME_TRACKING: 'Feuille de temps',
    SHIFTS_PLANNING: 'Planification des services',
    JOB_OVERVIEW: 'Aperçu du service',
    DISPONENT_OVERVIEW: 'Aperçu du planificateur',
    REQUESTER_OVERVIEW: 'Aperçu du demandeur',
    POOLER_OVERVIEW: 'Aperçu du pooler',
    AVAILABLE_USER_JOB_PLANNING: 'Planification du personnel',
    POOLER_REACTION_TIME: "Temps de réaction de l'employé",
    SMS_USAGE: 'Utilisation des SMS',
    USER_AVAILABILITY: "Disponibilité de l'utilisateur",
    ARCHIVED_JOBS: 'Services archivés et employés réservés',
    TRANSFER: 'Rapport de transfert',
    AVAILABILITY_UPDATES: 'Mises à jour des disponibilités',
    PLANNING_MATRIX: 'Matrice de planification',
    HOURS_BY_DEPARTMENT: 'Heures par département',
    CUSTOMER_CONNECTIONS: 'Clients connectés',
  },
  saveNote: 'Enregistrer la note',
  searchType: 'Rechercher par',
  all_alternative: 'Tout',
  times: 'Horaires',
  enterHours: 'Saisir les heures',
  enterHoursDescription: 'Veuillez saisir vos heures de travail pour ce jour.',
  inviteeInternalId: 'ID interne de l’employé',
};
